var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _polygon2, _polygon3, _polygon4, _rect7, _polygon5, _polygon6, _polygon7, _polygon8, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon9, _polygon10, _polygon11, _polygon12, _path2, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polygon13, _polygon14, _polygon15, _polygon16, _rect20, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _rect21, _rect22, _polygon23, _path3, _path4, _path5, _rect23, _polygon24, _polygon25, _polygon26, _polygon27, _rect24, _polygon28, _polygon29, _polygon30, _polygon31, _rect25, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _g, _path6, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExteriorPaintingCalgary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.93,230.22s-40.91,105.64,16.58,212S343.4,604.81,438.17,652.86s193.18,24.65,239.94-54.05S660.74,463.93,660.65,351.7s16.8-141.95-44-236.76S406.73-.87,294,69.46,150.93,230.22,150.93,230.22Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153,186.1C200.66,98.26,320.64-4.23,485.26,38.47s275.83,133,257.61,290.17-114,287.77-320.28,291.57S48.35,378.64,153,186.1Z",
    fill: "#0071f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153,186.1C200.66,98.26,320.64-4.23,485.26,38.47s275.83,133,257.61,290.17-114,287.77-320.28,291.57S48.35,378.64,153,186.1Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 223.47,
    width: 252.74,
    height: 162.76,
    fill: "#0071f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 223.47,
    width: 252.74,
    height: 162.76,
    fill: "#fff",
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 622.19,
    y: 223.47,
    width: 14.56,
    height: 162.76,
    fill: "#0071f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 417.32,
    width: 334.78,
    height: 162.1,
    fill: "#0071f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 417.32,
    width: 334.78,
    height: 162.1,
    fill: "#fff",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 540.81,
    y: 453.71,
    width: 50.28,
    height: 46.97,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "591.09 453.71 591.09 460.26 545.46 460.29 545.46 500.69 540.81 500.69 540.81 453.71 591.09 453.71",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "545.46 500.69 572.54 460.27 591.09 460.26 591.09 467.46 566.77 500.69 545.46 500.69",
    fill: "#fff",
    opacity: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "577.59 500.69 591.09 481.43 591.09 491.99 584.34 500.69 577.59 500.69",
    fill: "#fff",
    opacity: 0.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "545.46 460.29 545.46 472.71 554.24 460.26 545.46 460.29",
    fill: "#fff",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 616.23,
    y: 453.71,
    width: 50.28,
    height: 46.97,
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "666.51 453.71 666.51 460.26 620.89 460.29 620.89 500.69 616.23 500.69 616.23 453.71 666.51 453.71",
    fill: "#e6e6e6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "620.89 500.69 647.96 460.27 666.51 460.26 666.51 467.46 642.2 500.69 620.89 500.69",
    fill: "#fff",
    opacity: 0.2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.01 500.69 666.51 481.43 666.51 491.99 659.76 500.69 653.01 500.69",
    fill: "#fff",
    opacity: 0.2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "620.89 460.29 620.89 472.71 629.67 460.26 620.89 460.29",
    fill: "#fff",
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 386.22,
    width: 353.3,
    height: 13.23,
    fill: "#0071f2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 386.22,
    width: 353.3,
    height: 13.23,
    fill: "#fff",
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 399.46,
    width: 344.04,
    height: 18.53,
    fill: "#0071f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 399.46,
    width: 344.04,
    height: 18.53,
    opacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 436.93,
    y: 474.88,
    width: 60.87,
    height: 104.54,
    fill: "#2f2e41"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "497.8 474.88 497.8 480.17 442.98 480.17 442.98 579.42 436.93 579.42 436.93 474.88 497.8 474.88",
    fill: "#e6e6e6"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.14 480.17 442.98 517.88 442.98 531.69 488.92 480.17 478.14 480.17",
    fill: "#fff",
    opacity: 0.2
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "497.8 486.6 442.98 543.31 442.98 579.42 452.06 579.42 497.8 530.55 497.8 486.6",
    fill: "#fff",
    opacity: 0.2
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.37 579.42 497.8 548.13 497.8 556.92 476.73 579.42 467.37 579.42",
    fill: "#fff",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.51,525.5h-5.57a3.31,3.31,0,1,0,0,2.64h5.57Z",
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 540.15,
    y: 537.07,
    width: 166.73,
    height: 42.34,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 552.05,
    y: 537.07,
    width: 15.88,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 579.84,
    y: 537.07,
    width: 15.88,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 608.95,
    y: 537.07,
    width: 15.88,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 635.42,
    y: 537.07,
    width: 15.88,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 664.53,
    y: 537.07,
    width: 15.88,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 692.32,
    y: 537.07,
    width: 14.56,
    height: 42.34,
    fill: "#fff",
    opacity: 0.2
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "644.68 206.26 644.68 223.47 393.58 223.47 358.78 206.26 644.68 206.26",
    fill: "#0071f2"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "644.68 206.26 644.68 223.47 393.58 223.47 358.78 206.26 644.68 206.26",
    opacity: 0.2
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "650.64 193.03 650.64 206.93 358.2 206.93 332.03 193.03 650.64 193.03",
    fill: "#0071f2"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "650.64 193.03 650.64 206.93 358.2 206.93 332.03 193.03 650.64 193.03",
    fill: "#fff",
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 432.96,
    y: 256.55,
    width: 152.17,
    height: 92.63,
    fill: "#2f2e41"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.14 256.55 585.14 271.1 443.55 271.1 443.55 349.17 432.96 349.17 432.96 256.55 585.14 256.55",
    fill: "#e6e6e6"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.75 271.1 443.55 322.24 443.55 343.03 491.33 271.1 479.75 271.1",
    fill: "#fff",
    opacity: 0.2
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.06 349.17 510.37 271.1 553.1 271.1 499.79 349.17 457.06 349.17",
    fill: "#fff",
    opacity: 0.2
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.18 349.17 569.73 271.1 585.14 271.1 531.54 348.51 517.18 349.17",
    fill: "#fff",
    opacity: 0.2
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.84 187.08 158.37 244.23 158.37 579.42 389.3 579.42 389.3 243.74 274.84 187.08",
    fill: "#0071f2"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.84 187.08 158.37 244.23 158.37 579.42 389.3 579.42 389.3 243.74 274.84 187.08",
    fill: "#fff",
    opacity: 0.3
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 579.42,
    width: 584.87,
    height: 22.5,
    fill: "#0071f2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 579.42,
    width: 584.87,
    height: 22.5,
    opacity: 0.2
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.37 244.23 158.37 259.56 273.83 200.43 389.3 259.56 389.3 243.74 274.84 187.08 158.37 244.23",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.35,274.41a21.83,21.83,0,0,1-21.84,21.83,22.07,22.07,0,0,1-3.36-.26,21.63,21.63,0,0,1-9-3.57c-.5-.35-1-.72-1.48-1.11v0a21.83,21.83,0,0,1,26-35c.43.29.84.58,1.23.9a21.84,21.84,0,0,1,8.41,17.2Z",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.94,257.21a28.67,28.67,0,0,0-5.84-1.35c-14.16-1.69-25.79,10.7-24.06,24.85a45.52,45.52,0,0,0,2.62,10.57,21.82,21.82,0,0,1,27.28-34.07Z",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.67,262.3,270.15,296a21.63,21.63,0,0,1-9-3.57l24.56-36.1c.43.29.84.58,1.23.9A21.6,21.6,0,0,1,291.67,262.3Z",
    fill: "#fff",
    opacity: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 329.33,
    width: 71.45,
    height: 66.16,
    fill: "#2f2e41"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.3 329.32 258.3 338.55 193.46 338.59 193.46 395.49 186.84 395.49 186.84 329.32 258.3 329.32",
    fill: "#e6e6e6"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "193.46 395.49 231.93 338.57 258.3 338.56 258.3 348.69 223.74 395.49 193.46 395.49",
    fill: "#fff",
    opacity: 0.2
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.11 395.49 258.3 368.36 258.3 383.25 248.7 395.49 239.11 395.49",
    fill: "#fff",
    opacity: 0.2
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "193.46 338.59 193.46 356.09 205.94 338.56 193.46 338.59",
    fill: "#fff",
    opacity: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 286.08,
    y: 329.33,
    width: 71.45,
    height: 66.16,
    fill: "#2f2e41"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.54 329.32 357.54 338.55 292.7 338.59 292.7 395.49 286.08 395.49 286.08 329.32 357.54 329.32",
    fill: "#e6e6e6"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.7 395.49 331.17 338.57 357.54 338.56 357.54 348.69 322.98 395.49 292.7 395.49",
    fill: "#fff",
    opacity: 0.2
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.36 395.49 357.54 368.36 357.54 383.25 347.95 395.49 338.36 395.49",
    fill: "#fff",
    opacity: 0.2
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.7 338.59 292.7 356.09 305.18 338.56 292.7 338.59",
    fill: "#fff",
    opacity: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 217.28,
    y: 449.74,
    width: 112.48,
    height: 128.35,
    fill: "#2f2e41"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.75 449.74 329.75 457.67 225.88 457.67 225.88 578.09 217.28 578.09 217.28 449.74 329.75 449.74",
    fill: "#e6e6e6"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.88 520.18 283.46 457.67 269.52 457.67 225.88 505.4 225.88 520.18",
    fill: "#fff",
    opacity: 0.2
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.99 457.67 225.88 534.97 225.88 578.09 239.11 578.09 329.75 477.1 329.75 457.67 297.99 457.67",
    fill: "#fff",
    opacity: 0.2
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.43 578.09 329.75 500.33 329.75 513.92 267.41 578.09 256.43 578.09",
    fill: "#fff",
    opacity: 0.2
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "424.36 238.68 420.19 248.53 416.52 257.21 274.84 187.08 131.93 257.21 122.66 238.68 273.51 164.11 332.03 193.03 356.11 204.94 358.78 206.26 393.58 223.47 424.36 238.68",
    fill: "#0071f2"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.19 248.53 416.52 257.21 274.84 187.08 131.93 257.21 127.44 248.24 273.51 176.01 420.19 248.53",
    opacity: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 204.04,
    y: 432.54,
    width: 140.26,
    height: 17.2,
    fill: "#0071f2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 472.28,
    y: 267.17,
    width: 1.32,
    height: 81.97,
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 506.4,
    y: 267.86,
    width: 1.32,
    height: 81.97,
    fill: "#e6e6e6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 540.81,
    y: 266.47,
    width: 1.32,
    height: 81.97,
    fill: "#e6e6e6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 704.23,
    y: 416.66,
    width: 14.56,
    height: 162.76,
    fill: "#0071f2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 129.94,
    y: 596.62,
    width: 613.98,
    height: 23.82,
    fill: "#0071f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682.32,189.43v53.1s-121.26,40.33-145.78,52.28-50.88,36.75-50.88,36.75c-8.81,9.12-41.18,16.66-39.6,8.22a31.87,31.87,0,0,0,.2-9.25,43.62,43.62,0,0,0-1.76-8.39c-2.84,5.33-9.12,11.35-9.12,11.35,0,6.28-3.78,16.66-3.78,16.66l-1.41,20.1c6.44,11.63.76,16.33-1.68,16s-5.21-4.57-5.21-4.57l-3.65.49s-4.4,9.1-7.87,9.43-5.39-4.71-5.39-4.71-1.83,3.45-6.22,1.42a6.51,6.51,0,0,1-2.53-3c-2.74-5.49-4.26-16.37-4.7-20.33-.63-5-1.26-28.28-1.26-31.11s15.72-27,20.43-35.19,8.17-18.22,14.44-21.67,13.2-.64,33.62-1.89,38-5.34,47.26-8.8,11.49-8.16,25-11.36S681.38,189.76,682.32,189.43Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.84,320.2a68.67,68.67,0,0,1-2.58,10.3,43.62,43.62,0,0,0-1.76-8.39c-2.84,5.34-9.12,11.36-9.12,11.36,0,6.27-3.78,16.65-3.78,16.65l-1.41,20.1c6.44,11.63.76,16.33-1.68,16s-5.21-4.57-5.21-4.57l-3.65.49s-4.4,9.1-7.87,9.43-5.39-4.71-5.39-4.71-1.83,3.45-6.22,1.42a6.46,6.46,0,0,1-2.53-3c1.58.71,3.48,0,5.2-4.63A22.15,22.15,0,0,0,401,361.48s6.53-14,6.26-17.35-3.89-6.63-2.56-8.93,4.56,1.81,7.1-.8,11.92-17.29,11.53-18.95,2.37-1.56,3.81-2.84,1.1-7.48,3-6.72a40.44,40.44,0,0,1,4,1.91,15.2,15.2,0,0,0,0-4.26c-.36-.71,6.85,6.67,8.95,7S449.65,312.69,448.84,320.2Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,387.53a.78.78,0,0,1-.21,0,.6.6,0,0,1-.35-.76c.05-.14,5.05-14,.05-22.44a.61.61,0,0,1,0-.57,23.66,23.66,0,0,0,2.26-6.43c.91-4.73,2.31-14.41,1.92-15.75-.57-1.94,1.22-4,1.3-4.09a43.94,43.94,0,0,0,5.84-7c3-4.39,7.24-12.63,7.28-12.72a.56.56,0,0,1,.35-.29s3-1,6.55-5.24a.61.61,0,0,1,.29-.19c.17-.05,4.27-1.23,6.59,0a.6.6,0,0,1-.58,1c-1.48-.83-4.33-.32-5.51,0-3.21,3.79-5.93,5.06-6.74,5.38a145.58,145.58,0,0,1-7.25,12.63,44.56,44.56,0,0,1-6,7.19c-.37.43-1.35,1.86-1,2.95.56,1.91-1.33,13.39-1.89,16.3a24.46,24.46,0,0,1-2.22,6.46c5,8.9.1,22.58-.12,23.17A.59.59,0,0,1,406.42,387.53Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.52,326.09a.54.54,0,0,1-.22,0,.59.59,0,0,1-.33-.77c2-4.95,0-11.54,0-11.6a.6.6,0,0,1,.39-.74.58.58,0,0,1,.74.39c.09.28,2.16,7.05,0,12.39A.61.61,0,0,1,445.52,326.09Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.5,322.73a.6.6,0,0,1-.59-.5c-.23-1.36-1.14-5.16-2.56-6.41a.59.59,0,0,1,.78-.89c2,1.78,2.91,6.89,2.95,7.11a.6.6,0,0,1-.48.68Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.73,323.05c-7.43,0-11-4.49-11.18-4.71a.59.59,0,1,1,.93-.73c.18.23,4.48,5.57,13.63,3.94a.59.59,0,0,1,.69.48.61.61,0,0,1-.48.69A20.3,20.3,0,0,1,435.73,323.05Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.15,348.38h-.1a.58.58,0,0,1-.48-.68l1.42-8a.6.6,0,0,1,.15-.31c2.3-2.36,8.36-14,8.42-14.14a.59.59,0,0,1,.8-.25.58.58,0,0,1,.25.79c-.25.48-6,11.55-8.49,14.29l-1.39,7.83A.59.59,0,0,1,422.15,348.38Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.76,341.21a9.6,9.6,0,0,1-4-.89.6.6,0,0,1-.28-.79.58.58,0,0,1,.78-.28,8.41,8.41,0,0,0,7,0,.59.59,0,1,1,.5,1.07A9.6,9.6,0,0,1,416.76,341.21Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.31,337.4a2.24,2.24,0,0,1-1-.23.59.59,0,1,1,.54-1.05c1.17.61,4.32-1.45,6.18-3.11a.59.59,0,0,1,.78.88C435,334.55,431.69,337.4,429.31,337.4Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.85,313.2a.58.58,0,0,1-.59-.54,9.3,9.3,0,0,0-3.11-6.21.58.58,0,0,1,0-.83.59.59,0,0,1,.83-.06,10.48,10.48,0,0,1,3.5,7,.59.59,0,0,1-.53.64Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.16,311a.63.63,0,0,1-.42-.17c-2.28-2.28-6.47-8.61-6-9.82a.59.59,0,0,1,1.13.33c.11.86,3.14,6.08,5.71,8.65a.6.6,0,0,1,0,.84A.63.63,0,0,1,439.16,311Zm-5.31-9.57Zm0-.12",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.3,338.75a9,9,0,0,1-4.88-1.45.59.59,0,1,1,.65-1,7.72,7.72,0,0,0,6.59.89.59.59,0,0,1,.36,1.13A9.08,9.08,0,0,1,409.3,338.75Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.37,363.82c-.31,0-.51,0-.55,0a.6.6,0,0,1-.54-.63.58.58,0,0,1,.63-.55c1,.07,3.62,0,4.08-1.4a.59.59,0,1,1,1.12.38C407.44,363.6,404.59,363.82,403.37,363.82Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.14,
    cy: 390.6,
    rx: 11.19,
    ry: 14.18,
    transform: "translate(-35.6 41.38) rotate(-5.51)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.69,404.08a12.23,12.23,0,0,0-22.58.7L383,426.26a12.23,12.23,0,0,0,22.87,8.65L414,413.44A12.2,12.2,0,0,0,413.69,404.08Zm-9.2-.12a2.07,2.07,0,1,1,2.68-1.2,2.08,2.08,0,0,1-2.68,1.2Z",
    fill: "#0071f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.68,412.19l-8.12,21.47a8.7,8.7,0,0,1-16.27-6.15L394.41,406a8.47,8.47,0,0,1,3.8-4.43,8.9,8.9,0,0,0,11.44,5.26,9.74,9.74,0,0,0,1.14-.52A8.7,8.7,0,0,1,410.68,412.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.55,429.53a3,3,0,0,1-1.24-.32l-1.54-.58c-.91-.35-1.42-.17-1.63.53l-.2.54,4,1.52-.59,1.53L389.55,429l.9-2.33a2.11,2.11,0,0,1,2.49-1.66,2.41,2.41,0,0,1,.63.24l.77.3a2.1,2.1,0,0,1,1.59,1.76h0c.61-.66,1.42-.63,2.45-.25l1.51.59a3,3,0,0,0,1.26.28Zm-9-1.52,3,1.15.23-.6c.23-.58.1-1-.68-1.32l-1-.37c-.69-.27-1.09-.14-1.3.4Z",
    fill: "#0071f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,423.42l.79-2.11,1.42.54-.81,2.11,2.84,1.09,1-2.65,1.42.53-1.6,4.25-9.78-3.73,1.59-4.26,1.42.54-1,2.66Z",
    fill: "#0071f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.89,417.87h0l7.1,2.7-.52,1.42-9.79-3.74.73-1.93,6.46.68h0L395,414.78l.53-1.42,9.78,3.73-.6,1.59Z",
    fill: "#0071f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.77,412.72l1.8-4.76,1.42.53-.61,1.61,8.39,3.2-.59,1.53-8.39-3.19-.61,1.6Z",
    fill: "#0071f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,399.23,396.12,407a2.84,2.84,0,0,0-1.47,3.73l.06.11,10.16,21.78a2.84,2.84,0,0,0,3.74,1.47l.11,0,4.83-2.26,17.32,37.1a2,2,0,0,0,2.67,1h0l3.31-1.54a2,2,0,0,0,1-2.68h0l-17.32-37.1,4.84-2.25a2.85,2.85,0,0,0,1.47-3.74,1.17,1.17,0,0,0-.05-.11l-10.17-21.8a2.84,2.84,0,0,0-3.72-1.5Zm2.84,4.61a2.43,2.43,0,0,1-1.16,3.24h0l-.52.24a2.41,2.41,0,0,1-3.22-1.18l-.24-.51a2.43,2.43,0,0,1,1.16-3.23l.52-.25a2.44,2.44,0,0,1,3.23,1.19h0Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.89,467a.59.59,0,0,1-.53-.34l-17-36.48a.63.63,0,0,1,0-.45.59.59,0,0,1,.31-.33l1.77-.83a.6.6,0,0,1,.79.29.58.58,0,0,1-.29.78l-1.24.58,16.78,35.94a.59.59,0,0,1-.29.78A.54.54,0,0,1,433.89,467Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.26,389.56c.75,7.8-3.64,14.6-9.79,15.18",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.32,201.68V263l-4.81,1.25h0c-23.19,6-121.89,31.64-129.92,34.69-9.12,3.45-18.22,8.79-21.3,9.42s-19.48,19.16-24.51,23.88S484.51,342.24,470.36,346,443,359.84,439.58,363s-21.05,27-25.14,25.13c-3.21-1.49-7.81-2.38-7.91-9.16a26,26,0,0,1,1-6.85c3.45-13.21,11-23.57,18.22-26.08s24.5-24.82,25.13-30.49Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.47,264.2c-23.19,6-121.89,31.64-129.93,34.69-9.11,3.45-18.21,8.79-21.29,9.42s-19.48,19.16-24.51,23.88S484.46,342.24,470.32,346,443,359.84,439.54,363s-21.05,27-25.14,25.13c-3.21-1.49-7.81-2.38-7.91-9.16,2,3.23,5.27,7,6.57,5.56,0,0-3.82-.29,0-9.56s5.68-13.76,10.37-10.39,10.15,4.5,12-2.24,2.57-3.65,11.07-9.28,17.49-15.05,20-14.82,22.19-1.63,28.08-4.77,22.72-22.06,23.16-27.5,21.42-13.29,26.66-16.37,25.73-7,33.59-8.7-11.79,5.51-17.69,9.62,49.7-14.12,64.3-16.93C638.91,270.83,676,264.45,677.47,264.2Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,490.05c-7.67,7.7-30.87,18.67-39.18,24.57-5.87,4.17-30.37,8-37.49,10-5.06,1.49-11.8,7.28-18.54,5.36s-62.91-28.89-76.39-35.62-83.13,3.84-124.68,2.47c-2.71-.08-5.31-.17-7.8-.22-35.76-1-49.5.22-49.5.22l19.09-73.82s35.44,1.7,89.39,11.25c10.89,1.93,20.76,3.48,29.59,4.75,34.92,5,53.52,5.32,53.52,5.32s18-15.62,34.83-2.2,21.3,24.7,21.3,24.7l23.59,13.49s9.56-1.69,15.45,0,14.2-3.93,18.46-6.17a73.37,73.37,0,0,1,24-7.32s14.53-5.6,25.2-2.84c0,0,7.87-3.36,14.61-3.36a12.1,12.1,0,0,1,5.07,1.05,10.33,10.33,0,0,1,4.47,3.72,47.39,47.39,0,0,1,1.13,5.91C507.68,475.32,498.13,472.85,481,490.05Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,490.05c-7.67,7.7-30.87,18.67-39.18,24.57-5.87,4.17-30.37,8-37.49,10-5.06,1.49-11.8,7.28-18.54,5.36s-62.91-28.89-76.39-35.62-83.13,3.84-124.68,2.47c-2.71-.08-5.31-.17-7.8-.22,18-1.18,36.92-2.56,42.75-3.51,12-2,71.76-5.06,80.06-5.77s73.83,33.38,81.33,36.75,12.78,3.75,17.65,0S423,517,423,517l-11.15,1s14.83-5.37,24.46-7.75,19.19-11.09,25.55-13.11,17.41-14.64,23-17.23,0-10.31,0-10.31,6.72-.26,9.36,3.9c0,0,9.82.33,11.84-8.05a47.7,47.7,0,0,1,1.12,5.91C507.68,475.32,498.13,472.85,481,490.05Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.52,461.76c-16.23,4.26-19.68,7-19.68,7-2.95-.88-22.13,11.22-23.76,12.2s-2.6,5.67-2.6,5.67-5.51-5.67-14.85.84S430.26,498,430.26,498l-3.75-4.79s-15.85,1.42-20.7.63a23.45,23.45,0,0,1-11-4.44c-3.7-2.47-23.41-10.76-25.44-11.36s-4.6-4.37-4.6-4.37c-3.59-14.42-21.5-30.89-31.23-29.59a35.74,35.74,0,0,0-16.23,6.56s-18.23-1.87-27.59-2.24-66.27-10.86-66.27-10.86l42,1.42c34.93,5,53.53,5.32,53.53,5.32s18-15.62,34.83-2.2,21.29,24.7,21.29,24.7l23.6,13.49s9.55-1.69,15.45,0,14.19-3.93,18.45-6.17a73.6,73.6,0,0,1,24-7.32s14.52-5.6,25.2-2.84c0,0,7.86-3.36,14.61-3.36A12.23,12.23,0,0,1,501.52,461.76Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,484.16s.1,4-2,3.61,3.76,5.46,7.5,4.53,12.92,7.49,16.48,11.24,34.54,8.61,41.17,8.42,11.63-7,7-13.9c0,0-.85,6.79-5,6,0,0,4-1.5-2-7.1S382,489,380.16,490.07s-13.26-3.55-13.93-4.26,1,16.2-8.92,15.62c0,0-11.11-8.21-13.33-11.6S333.6,484.16,333.6,484.16Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.39,519.67a.59.59,0,0,1-.29-1.11c3.19-1.83,8.39-2.89,14.41-4.12,7.61-1.56,16.25-3.32,22.06-7.09,4.95-3.21,9.66-5.71,13.81-7.9,4.43-2.35,8.25-4.37,10.56-6.38,4.19-3.64,17.8-12.61,20-14.06a13,13,0,0,0-2.13-6.46c-1.94-2.67-7.81-4.5-13.09-2.84S453.41,481.88,453.25,482a.61.61,0,0,1-.17.07c-11.09,3-25.92,8.63-26.07,8.69a.78.78,0,0,1-.21,0H409.39a.6.6,0,0,1,0-1.19h17.3c1.33-.5,15.34-5.78,26-8.65,1.38-.91,16.47-10.74,21.69-12.37s11.9-.16,14.41,3.29a14.25,14.25,0,0,1,2.36,7.43.63.63,0,0,1-.27.52c-.16.1-15.75,10.31-20.15,14.14-2.41,2.1-6.11,4.06-10.78,6.53-4.14,2.19-8.82,4.67-13.72,7.85-6,3.89-14.76,5.68-22.48,7.26-5.67,1.16-11,2.25-14.05,4A.67.67,0,0,1,409.39,519.67Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.32,480.52a.62.62,0,0,1-.4-.15.6.6,0,0,1,0-.84c8.31-9.13,26-15.74,26.76-16a.59.59,0,0,1,.76.35.61.61,0,0,1-.35.76c-.18.06-18.18,6.78-26.29,15.7A.59.59,0,0,1,455.32,480.52Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.51,487.93a.59.59,0,0,1-.56-.43.59.59,0,0,1,.4-.73c9.73-2.78,23.33-6.42,23.47-6.46a.59.59,0,0,1,.3,1.14c-.13,0-13.72,3.68-23.44,6.46A.5.5,0,0,1,426.51,487.93Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.26,486.43a.59.59,0,0,1-.56-.39c-1.34-3.76,0-5.67.08-5.75a.59.59,0,0,1,1,.7c-.06.07-1,1.55.07,4.65a.59.59,0,0,1-.35.75A.51.51,0,0,1,417.26,486.43Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.58,508.8a88.7,88.7,0,0,1-12.19-1.19l-3.73-.52c-9.12-1.27-16.32-2.26-21-4.42-2.83-1.3-5.35-4.76-7.79-8.1-1.87-2.56-3.63-5-5.16-5.81-3.59-1.94-10.27-4.95-10.34-5a.6.6,0,0,1-.3-.78.6.6,0,0,1,.79-.3c.06,0,6.79,3.06,10.41,5,1.77.95,3.61,3.48,5.56,6.15,2.24,3.07,4.77,6.55,7.33,7.73,4.52,2.08,11.65,3.07,20.67,4.32l3.74.52c9.52,1.37,21.37,3.06,23.31-4.73,1.79-7.19-9.12-12.41-17.09-16.23-1.26-.6-2.46-1.17-3.52-1.71a57.81,57.81,0,0,0-13.11-5,.76.76,0,0,1-.26-.15s-3.92-3.7-5.32-5.09c-.85-.86-1.19-2.94-1.67-6.28a33.21,33.21,0,0,0-1.31-6.43.6.6,0,0,1,.35-.76.59.59,0,0,1,.76.35,34.19,34.19,0,0,1,1.37,6.67c.34,2.34.72,5,1.34,5.61,1.25,1.25,4.53,4.36,5.18,5a59.62,59.62,0,0,1,13.22,5.11c1,.53,2.23,1.1,3.48,1.7,8.34,4,19.75,9.45,17.73,17.57C402.69,507.34,397.6,508.8,391.58,508.8Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,474.36a.66.66,0,0,1-.35-.11.6.6,0,0,1-.13-.83c2.34-3.2,2.73-9.32,2.73-9.38a.59.59,0,1,1,1.18.07c0,.26-.41,6.53-2.95,10A.6.6,0,0,1,364.81,474.36Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,487.15a.52.52,0,0,1-.21,0,.59.59,0,0,1-.34-.76,19,19,0,0,1,4.06-6.37.58.58,0,0,1,.83,0,.59.59,0,0,1,0,.84,17.86,17.86,0,0,0-3.81,6A.58.58,0,0,1,394.78,487.15Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,488.73a33.55,33.55,0,0,1-6.63-.77.59.59,0,0,1,.25-1.15c.08,0,7.33,1.62,10.41.05a.59.59,0,1,1,.54,1.05A10.55,10.55,0,0,1,336.12,488.73Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9,476.42a.59.59,0,0,1-.3-1.1,10,10,0,0,0,3.92-4.33.6.6,0,0,1,.79-.28.59.59,0,0,1,.28.78,11.14,11.14,0,0,1-4.39,4.85A.64.64,0,0,1,366.9,476.42Z",
    fill: "#f29079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.4,499.49a.58.58,0,0,1-.5-.28.61.61,0,0,1,.19-.82c6-3.67,5.11-10.63,5.07-10.92a.59.59,0,0,1,.49-.67.6.6,0,0,1,.67.5c0,.08,1.11,8-5.61,12.1A.59.59,0,0,1,359.4,499.49Z",
    fill: "#f29079"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.59,165.77v-6.16h77.13a16.49,16.49,0,0,0,16.48-16.49v-15h60.13a6.6,6.6,0,0,0,6.52-6.66v-30a6.59,6.59,0,0,0-6.59-6.58H354.81a6.6,6.6,0,0,0-6.59,6.6v30.07a6.61,6.61,0,0,0,6.59,6.61h60v12.38a8.65,8.65,0,0,1-8.65,8.65H331.62v-6.14l-15.23,11.32Z",
    fill: "#fff"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "472.43 103.21 479.4 104.23 474.35 109.14 475.54 116.09 469.3 112.82 463.06 116.09 464.25 109.14 459.22 104.23 466.19 103.21 469.3 96.89 472.43 103.21",
    fill: "#0071f2"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.8 103.21 454.77 104.23 449.72 109.14 450.92 116.09 444.67 112.82 438.43 116.09 439.63 109.14 434.58 104.23 441.56 103.21 444.67 96.89 447.8 103.21",
    fill: "#0071f2"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.18 103.21 430.15 104.23 425.1 109.14 426.29 116.09 420.05 112.82 413.81 116.09 415 109.14 409.95 104.23 416.94 103.21 420.05 96.89 423.18 103.21",
    fill: "#0071f2"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.54 103.21 405.52 104.23 400.48 109.14 401.67 116.09 395.43 112.82 389.18 116.09 390.38 109.14 385.33 104.23 392.3 103.21 395.43 96.89 398.54 103.21",
    fill: "#0071f2"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.92 103.21 380.9 104.23 375.85 109.14 377.05 116.09 370.8 112.82 364.56 116.09 365.75 109.14 360.7 104.23 367.67 103.21 370.8 96.89 373.92 103.21",
    fill: "#0071f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExteriorPaintingCalgary);
export default __webpack_public_path__ + "static/media/exterior-painting-calgary.0fcf0534e4ecd2ff7b42fc7252b4576f.svg";
export { ForwardRef as ReactComponent };